import React from 'react';
import {
  ChatThreadPlaceHolderBox,
  ChatThreadBgBox,
  ChatThreadPlaceHolderContainer,
  ChatThreadPlaceHolderColumn,
  ChatThreadPlaceHolderQuestionItem,
  ChatThreadPlaceHolderIconContainer,
} from './styled';
import { useAtomValue } from 'jotai';
import { questionsInWelcomePageAtom } from '../atoms';
import useHandleUserMessage from '../hooks/useHandleUserMessage';
import { CATEGORY_ICON_MAP } from '../utils';

function ChatThreadBgPlaceholder({ getStream }) {
  const questionList = useAtomValue(questionsInWelcomePageAtom);
  const { submitQuestion } = useHandleUserMessage({ getStream });

  const handleQuestionClick = (question) => {
    submitQuestion(question);
  };

  return (
    <ChatThreadPlaceHolderBox>
      <ChatThreadBgBox>
        <ChatThreadPlaceHolderContainer>
          {questionList.map((category) => {
            const Icon = CATEGORY_ICON_MAP[category.title];
            return (
              <ChatThreadPlaceHolderColumn key={category.title}>
                {category.questions.map((question) => {
                  return (
                    <ChatThreadPlaceHolderQuestionItem
                      key={question}
                      onClick={() => {
                        handleQuestionClick(question);
                      }}
                    >
                      <ChatThreadPlaceHolderIconContainer>
                        <Icon />
                      </ChatThreadPlaceHolderIconContainer>
                      <span>{question}</span>
                    </ChatThreadPlaceHolderQuestionItem>
                  );
                })}
              </ChatThreadPlaceHolderColumn>
            );
          })}
        </ChatThreadPlaceHolderContainer>
      </ChatThreadBgBox>
    </ChatThreadPlaceHolderBox>
  );
}

export default ChatThreadBgPlaceholder;
